import { jsx as _jsx } from "react/jsx-runtime";
import frownIcon from '@jetbrains/icons/frown';
import ErrorMessage from '@jetbrains/ring-ui/components/error-message/error-message';
import NavigationLink from '../navigation/navigation-link';
export default function LoadingError() {
    return (_jsx(ErrorMessage, { icon: frownIcon, code: "Error", message: "Unable to load data from server.", description: "Please try again soon.", children: _jsx(NavigationLink, { href: "/", children: "Go to the welcome page" }) }));
}
